import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-header',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit {

    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

}